import { render, staticRenderFns } from "./TheRefundProtect.vue?vue&type=template&id=49dc882c"
import script from "./TheRefundProtect.vue?vue&type=script&lang=js"
export * from "./TheRefundProtect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports